var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"video-embed light green"},[_c('circles-layout'),_vm._v(" "),_c('ogt-video',{ref:"video",attrs:{"src":"/static/video/onderwijs-in-coronatijd.mp4","muted":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }